import React, { useRef, useState } from "react";
import { CiCalendar } from "react-icons/ci";
import { IoIosArrowForward } from "react-icons/io";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

// all css comes in FilterBox.css in PreReadFile  justify-content-between
// py-2 mt-2

const FilterBox = ({
  setChecked,
  checked,
  setFilter,
  filter,
  setClick1,
  setAllPost,
}) => {
  const { sortChecked, timeChecked } = checked;
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [date, setDate] = useState("");
  const dateInputRef = useRef(null);

  const handleCalendarClick = () => {
    if (dateInputRef.current) {
      dateInputRef.current.setOpen(true);
    }
    setShowDatePicker(!showDatePicker);
  };

  const handleDateChange = (date) => {
    const selectedDate = date;
    setDate(selectedDate);
  };

  const handleSortCheckboxChange = (e, index) => {
    setAllPost([]);
    setChecked({ ...checked, sortChecked: index === sortChecked ? 1 : index });
    setFilter({ ...filter, page: 1, sortBy: e.target.value });

    setAllPost([]);
  };
  const [dateClick, setDateClick] = useState(null);

  const handleTimeCheckboxChange = (e, index) => {
    setChecked({ ...checked, timeChecked: index === timeChecked ? 1 : index });
    setDateClick(e.target.value);
  };

  function formatDateToString(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  const handleButton = () => {
    setAllPost([]);
    if (date && !dateClick) {
      setFilter({
        ...filter,
        name: null,
        tag: null,
        page: 1,
        date: formatDateToString(date),
      });
    } else {
      setFilter({ ...filter, page: 1, time: dateClick });
    }
    setClick1(false);
  };

  return (
    <>
      <div className="p-2 ">
        <div className="d-flex align-items-center justify-content-between">
          <h4 className="filter_heading">Filter</h4>
          <img
            src="/images/UpArrow.svg"
            alt=""
            style={{ cursor: "pointer" }}
            onClick={(e) => setClick1(false)}
          />
        </div>
        {/* gap-2 px-3   col-5    d-flex align-item-center flex-column subject_subbox */}
        {/* <div className="mx-2">
          <h5 className="mb-2 filter_first_heading">Date</h5>
          <div className="">
            <div className="form-check">
              <input
                style={{ cursor: "pointer" }}
                className="form-check-input"
                type="checkbox"
                value="1"
                id="flexCheckDefault"
                checked={1 === sortChecked}
                onChange={(e) => handleSortCheckboxChange(e, 1)}
              />
              <span>asce</span>
            </div>
            <div className="form-check">
              <input
                style={{ cursor: "pointer" }}
                className="form-check-input"
                type="checkbox"
                value="-1"
                id="flexCheckDefault"
                checked={2 === sortChecked}
                onChange={(e) => handleSortCheckboxChange(e, 2)}
              />
              <span>desc</span>
            </div>
          </div>
        </div> */}
        <div className="mx-2">
          {/* <h5 className="mb-2 filter_first_heading">TIME</h5> */}
          <div>
            {/* <div className="form-check">
              <input
                style={{ cursor: "pointer" }}
                className="form-check-input"
                type="checkbox"
                value="null"
                id="flexCheckDefault"
                checked={1 === timeChecked}
                onChange={(e) => handleTimeCheckboxChange(e, 1)}
              />
              <span>All day</span>
            </div> */}
            <div className="form-check">
              <input
                style={{ cursor: "pointer" }}
                className="form-check-input"
                type="checkbox"
                value="today"
                id="flexCheckDefault"
                checked={2 === timeChecked}
                onChange={(e) => handleTimeCheckboxChange(e, 2)}
              />
              <span>Today</span>
            </div>
            <div className="form-check">
              <input
                style={{ cursor: "pointer" }}
                className="form-check-input"
                type="checkbox"
                value="yesterday"
                id="flexCheckDefault"
                checked={3 === timeChecked}
                onChange={(e) => handleTimeCheckboxChange(e, 3)}
              />
              <span>Yesterday</span>
            </div>
            <div className="form-check">
              <input
                style={{ cursor: "pointer" }}
                className="form-check-input"
                type="checkbox"
                value="thisweek"
                id="flexCheckDefault"
                checked={4 === timeChecked}
                onChange={(e) => handleTimeCheckboxChange(e, 4)}
              />
              <span>This Week</span>
            </div>
            <div className="form-check">
              <input
                style={{ cursor: "pointer" }}
                className="form-check-input"
                type="checkbox"
                value="thismonth"
                id="flexCheckDefault"
                checked={5 === timeChecked}
                onChange={(e) => handleTimeCheckboxChange(e, 5)}
              />
              <span>This Month</span>
            </div>

            <div className="d-flex align-items-center justify-content-between">
              <span id="calendarIcon" onClick={handleCalendarClick}>
                <CiCalendar color="#F77F00" />
              </span>
              <span id="pickDateText" onClick={handleCalendarClick}>
                Pick a date
              </span>
              <span id="arrowIcon" onClick={handleCalendarClick}>
                <IoIosArrowForward />
              </span>
            </div>
            <DatePicker
              selected={date}
              className="d-none"
              showYearDropdown
              yearDropdownItemNumber={15}
              showMonthDropdown
              onChange={handleDateChange}
              ref={dateInputRef}
            />

            <div className="d-flex justify-content-between mt-1">
              <button
                onClick={() => {
                  setFilter({ ...filter, page: 1, time: null, date: null });
                  setChecked({ ...checked, timeChecked: null });
                  setClick1(false);
                }}
                className="buttonsfilter"
              >
                Clear
              </button>
              <button onClick={handleButton} className="buttonsfilter2 ml-2">
                Apply
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FilterBox;
